import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, resolveComponent as _resolveComponent, resolveDynamicComponent as _resolveDynamicComponent, renderSlot as _renderSlot, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, createVNode as _createVNode, withModifiers as _withModifiers, createElementVNode as _createElementVNode, Fragment as _Fragment, normalizeStyle as _normalizeStyle, Teleport as _Teleport } from "vue"

const _hoisted_1 = ["aria-label"]

import { computed, ref, Ref } from 'vue';
import scrollService from '@/core/scroll/scroll.service';
import VimeoEmbed from '@/shared/media/VimeoEmbed.vue';
import { ImageFileModel } from '@/types/B2BcontentServerContract';
import pageStore from '@/shared/content/page.store';
import breakpointsState from '@/core/responsive/breakpoints/breakpoints-state.observable';
import siteContextStore from '@/shared/content/site-context.store';
import FallbackImageTransition from '@/shared/media/transitions/FallbackImageTransition.vue';
import ImageTransition from '@/shared/media/transitions/ImageTransition.vue';
import VideoEmbed from '@/shared/content/blocks/helpers/VideoEmbed.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'HeroBanner',
  props: {
    title: { default: '' },
    image: { default: undefined },
    video: { default: undefined },
    vimeoId: { default: '' },
    campaignMode: { type: Boolean, default: false },
    autoplay: { type: Boolean },
    scrim: { type: Boolean, default: true },
    textColor: { default: '#ffffff' }
  },
  setup(__props: any) {

const props = __props as { title: string, image: ImageFileModel, video: ImageFileModel, vimeoId: string, campaignMode: boolean, autoplay?: boolean, scrim: boolean, textColor: string }


const contentScrollTarget: Ref<HTMLElement | null> = ref(null);

const pageHasContentTiles: Ref<boolean> = computed(() => pageStore.hasContentTiles);

const scrollToContent = (): void => {
    scrollService.scrollToElement(contentScrollTarget.value as HTMLElement, 0, 300);
};

const imageTransition = computed(() => {
    return showImage.value && isVimeoWithFallbackImage.value ? FallbackImageTransition : ImageTransition;
});

const isVimeoWithFallbackImage = computed(() => {
    return (!!props.vimeoId && !!props.image) ?? false;
});

const disableVideoOnMobile = computed(() => {
    const isMobileOrTablet = breakpointsState.activeBreakpoint === 'xs' || breakpointsState.activeBreakpoint === 'sm' || breakpointsState.activeBreakpoint === 'md';
    return isMobileOrTablet && siteContextStore.heroBannerSettings.disableVideoOnMobile;
});

const showImage = computed(() => {
    return (props.image || isVimeoWithFallbackImage.value) || disableVideoOnMobile.value;
});

const isNativeVideo = computed(() => {
    return !!(props.video && props.video.url);
});

const showVideo = computed(() => {
    return !!((props.vimeoId !== '' || isNativeVideo.value) && !disableVideoOnMobile.value && !siteContextStore.heroBannerSettings.disableVideoOnAllDevices);
});

return (_ctx: any,_cache: any) => {
  const _component_ResponsiveImage = _resolveComponent("ResponsiveImage")!
  const _component_c_icon = _resolveComponent("c-icon")!

  return (_openBlock(), _createBlock(_Teleport, { to: "#tp-hero" }, [
    _createElementVNode("div", {
      class: "c-hero-banner",
      style: _normalizeStyle({color:__props.textColor})
    }, [
      (_unref(showVideo))
        ? (_openBlock(), _createBlock(_Transition, {
            key: 0,
            name: "o-anim-fade-300",
            mode: "out-in",
            appear: ""
          }, {
            default: _withCtx(() => [
              (_unref(isNativeVideo))
                ? (_openBlock(), _createBlock(VideoEmbed, {
                    key: 0,
                    url: __props.video.url,
                    title: __props.title,
                    class: ""
                  }, null, 8, ["url", "title"]))
                : (_openBlock(), _createBlock(VimeoEmbed, {
                    key: __props.vimeoId,
                    "src-id": __props.vimeoId,
                    title: __props.title,
                    autoplay: __props.autoplay,
                    "aspect-ratio": { 'max-sm': 1, 'default': 16/9}
                  }, null, 8, ["src-id", "title", "autoplay"]))
            ]),
            _: 1
          }))
        : (_unref(showImage))
          ? (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(imageTransition)), { key: 1 }, {
              default: _withCtx(() => [
                (__props.image)
                  ? (_openBlock(), _createBlock(_component_ResponsiveImage, {
                      key: __props.image.url,
                      "image-url": __props.image.url,
                      "aspect-ratio": { 'max-sm': 1, 'default': 16/9},
                      lazy: false,
                      "focus-points": __props.image.focusPoints,
                      focus: __props.image.focus,
                      zoom: __props.image.zoom,
                      alt: __props.title,
                      "bg-color": __props.image.hexCode,
                      "original-height": __props.image.height,
                      "original-width": __props.image.width,
                      flip: __props.image.flip,
                      "cache-bust": __props.image.cachebust
                    }, null, 8, ["image-url", "focus-points", "focus", "zoom", "alt", "bg-color", "original-height", "original-width", "flip", "cache-bust"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
      _renderSlot(_ctx.$slots, "default", {
        tag: "div",
        class: "c-hero-banner__content"
      }, () => [
        _createVNode(_Transition, {
          name: "c-hero-banner__title-anim",
          mode: "out-in",
          appear: ""
        }, {
          default: _withCtx(() => [
            (_openBlock(), _createElementBlock("h1", {
              key: __props.title,
              class: _normalizeClass(["c-hero-banner__title", {'text-shadow': __props.scrim}])
            }, _toDisplayString(__props.title), 3))
          ]),
          _: 1
        })
      ]),
      (_unref(pageHasContentTiles))
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
            _createElementVNode("button", {
              type: "button",
              class: "c-hero-banner__scroll-link",
              "aria-label": _ctx.$dictionary.get('global/a11y/herogotocontent'),
              onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (scrollToContent()), ["prevent"]))
            }, [
              _createVNode(_component_c_icon, {
                name: "icon-arrow-wide-down",
                width: "70",
                height: "70",
                class: _normalizeClass({'drop-shadow': __props.scrim})
              }, null, 8, ["class"])
            ], 8, _hoisted_1),
            _createElementVNode("div", {
              ref_key: "contentScrollTarget",
              ref: contentScrollTarget,
              class: "c-hero-banner__content-scroll-target"
            }, null, 512)
          ], 64))
        : _createCommentVNode("", true)
    ], 4)
  ]))
}
}

})